const TYPE = "cliente";
/*const fields = [
  "_id",
  "_rev",
  "idIntegracao",
  "desc",
  "fantasia",
  "contatos",
  "enderecos"
];*/

const clienteModule = {
  findAll: async (dbConnection, fields = null) => {
    let clientes = [];

    let vendedoresStorage = localStorage.getItem("usuarioVendedores");
    if (vendedoresStorage === null) {
      alert("ERRO contate o administrador");
    }
    let vendedores = JSON.parse(vendedoresStorage);

    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        //$or: [],
        "vendedor.idIntegracao": { $eq: vendedores[0].idIntegracao },
      },
      fields: [
        "_id",
        "idIntegracao",
        "desc",
        "cnpjCpf",
        "fantasia",
        "descFormat",
        "vendedor",
      ],
      limit: 5,
    };

    if (fields) {
      query.fields = fields;
    }

    // for (let vendedor of vendedores) {
    //   query.selector.$or.push({
    //     "vendedor.idIntegracao": vendedor.idIntegracao,
    //   });
    // }
    let result = await dbConnection.find(query);

    if (result.docs.length) {
      clientes = result.docs;
    }

    return clientes;
  },

  findTitulo: async (dbConnection, id) => {
    id = parseInt(id);
    let titulos = [];
    let query = {
      selector: {
        type: { $eq: "tituloAtraso" },
        "cliente.idIntegracao": { $eq: id },
      },
      limit: 1,
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      titulos = result.docs;
    }

    return titulos;
  },

  findById: async (dbConnection, id) => {
    let cliente = null;
    let query = {
      selector: {
        type: { $eq: TYPE },
        _id: { $eq: id },
        status: { $eq: "A" },
      },
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      cliente = result.docs[0];
    }

    return cliente;
  },

  findAllByDesc: async (dbConnection, desc) => {
    desc = desc.toUpperCase();
    desc = "^.*" + desc;
    let clientes = [];

    let vendedoresStorage = localStorage.getItem("usuarioVendedores");

    if (vendedoresStorage === null) {
      alert("ERRO contate o administrador");
    }

    let vendedores = JSON.parse(vendedoresStorage);

    // for (let vendedor of vendedores) {
    //   query.selector.$or.push({
    //     "vendedor.idIntegracao": vendedor.idIntegracao,
    //   });
    // }

    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        descFormat: { $regex: desc },
        //  $or: [],
        "vendedor.idIntegracao": { $eq: vendedores[0].idIntegracao },
      },
      fields: [
        "_id",
        "idIntegracao",
        "desc",
        "cnpjCpf",
        "fantasia",
        "descFormat",
        "vendedor",
      ],
      limit: 15,
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      clientes = result.docs;
    }

    return clientes;
  },

   findAllTeste: async (dbConnection, desc) => {
    let clientes = [];

    let vendedoresStorage = localStorage.getItem("usuarioVendedores");

    if (vendedoresStorage === null) {
      alert("ERRO contate o administrador");
    }

    let vendedores = JSON.parse(vendedoresStorage);

    // for (let vendedor of vendedores) {
    //   query.selector.$or.push({
    //     "vendedor.idIntegracao": vendedor.idIntegracao,
    //   });
    // }

    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        //  $or: [],
        "vendedor.idIntegracao": { $eq: vendedores[0].idIntegracao },
      },
      fields: [
        "_id",
        "idIntegracao",
        "desc",
        "cnpjCpf",
        "fantasia",
        "descFormat",
        "vendedor",
      ],
      limit: 15,
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      clientes = result.docs;
    }

    return clientes;
  },

  update: async (dbConnection, cliente) => {
    await dbConnection.put(cliente);
  },

  totalClientes: async (dbConnection) => {
    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
      },
      fields: ["_id"],
      limit: 50000,
    };

    let result = await dbConnection.find(query);
    return result.docs.length;
  },

  findTabelaPreco: async (dbConnection, idIntegracao) => {
    let cliente = null;
    let query = {
      selector: {
        type: { $eq: TYPE },
        idIntegracao: { $eq: idIntegracao },
        status: { $eq: "A" },
      },
      fields: ["_id", "desc", "tabelaPreco"],
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      cliente = result.docs[0];
    }

    return cliente;
  },

  findAllPorCidade: async (dbConnection, cidade) => {
    let clientes = [];
    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        enderecos: {
          $elemMatch: {
            cidade: cidade,
          },
        },
      },
      fields: [
        "_id",
        "cod",
        "idIntegracao",
        "desc",
        "fantasia",
        "cnpjCpf",
        "descFormat",
      ],
      limit: 9999,
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      clientes = result.docs;
    }

    return clientes;
  },

  verificaExisteTitulos: async (dbConnection, id) => {
    id = parseInt(id);
    let query = {
      selector: {
        type: { $eq: "tituloAtraso" },
        "cliente.idIntegracao": { $eq: id },
      },
      limit: 1,
    };

    let result = await dbConnection.find(query);
    let existeTitulos = false;

    if (result.docs.length) {
      existeTitulos = true;
    }

    return existeTitulos;
  },

  buscarTitulos: async (dbConnection, id) => {
    id = parseInt(id);
    let titulos = [];
    let query = {
      selector: {
        type: { $eq: "tituloAtraso" },
        "cliente.idIntegracao": { $eq: id },
      },
      limit: 9999,
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      titulos = result.docs;
    }

    return titulos;
  },
};

export default clienteModule;
